// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AgendaPage {
    margin-top: 10vh;
}

.agenda-page {
    padding: 80px 20px;
    background-color: #f8f9fa;
    min-height: calc(100vh - 20vh);
}

.agenda-container {
    max-width: 1400px;
    margin: 0 auto;
}

.agenda-title {
    font-size: 2.5rem;
    text-align: center;
    margin-bottom: 30px;
    color: #333;
}

.agenda-intro {
    font-size: 1.1rem;
    line-height: 1.8;
    text-align: center;
    margin-bottom: 50px;
    color: #555;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
}

.agenda-table {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    overflow: hidden;
}

.agenda-row {
    display: grid;
    grid-template-columns: 180px 1fr 400px;
    gap: 25px;
    padding: 25px 20px;
    border-bottom: 1px solid #e9ecef;
    align-items: center;
}

.agenda-row:last-child {
    border-bottom: none;
}

.agenda-row.header {
    background-color: #2c3e50;
    color: white;
    font-weight: bold;
    border-bottom: 3px solid #1a252f;
    padding: 20px;
}

.agenda-row.header .agenda-time,
.agenda-row.header .agenda-item,
.agenda-row.header .agenda-people {
    color: white;
    font-size: 1rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    text-align: center;
}

.agenda-row.highlight {
    background-color: #f8f9fa;
}

.agenda-time {
    font-weight: 600;
    color: #2c3e50;
    font-size: 0.95rem;
    white-space: nowrap;
    text-align: center;
}

.agenda-item {
    color: #333;
    line-height: 1.7;
    font-size: 0.95rem;
    text-align: center;
}

.agenda-item strong {
    color: #2c3e50;
    font-size: 1.05rem;
    display: block;
    margin-bottom: 5px;
}

.agenda-item em {
    color: #2c3e50;
    font-size: 0.95rem;
    display: block;
    margin-bottom: 4px;
}

.agenda-abstract {
    font-size: 0.85rem;
    color: #666;
    line-height: 1.6;
    display: block;
    margin-top: 4px;
}

.agenda-people {
    color: #555;
    font-size: 0.9rem;
    line-height: 1.8;
    text-align: center;
}

.agenda-people strong {
    color: #2c3e50;
    font-weight: 600;
    display: block;
    margin-top: 8px;
    margin-bottom: 4px;
}

.agenda-people strong:first-child {
    margin-top: 0;
}

@media (max-width: 1024px) {
    .agenda-row {
        grid-template-columns: 150px 1fr 300px;
        gap: 20px;
        padding: 20px 15px;
    }
}

@media (max-width: 768px) {
    .agenda-row {
        grid-template-columns: 1fr;
        gap: 12px;
        padding: 20px 15px;
        align-items: flex-start;
    }
    
    .agenda-time {
        font-weight: bold;
        margin-bottom: 8px;
        font-size: 1rem;
        color: #2c3e50;
        text-align: left;
    }
    
    .agenda-item {
        margin-bottom: 12px;
        text-align: left;
    }
    
    .agenda-people {
        margin-bottom: 0;
        text-align: left;
    }
    
    .agenda-title {
        font-size: 2rem;
    }
    
    .agenda-intro {
        font-size: 1rem;
    }
    
    .agenda-row.header {
        display: none;
    }
}

.agenda-subtitle {
    font-size: 0.9em;
    font-weight: normal;
    color: #555;
}

.agenda-link {
    color: #57068c;
    text-decoration: none;
    font-weight: 500;
}
.agenda-link:hover {
    text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/pages/AgendaPage/AgendaPage.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,sCAAsC;IACtC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,SAAS;IACT,kBAAkB;IAClB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,gCAAgC;IAChC,aAAa;AACjB;;AAEA;;;IAGI,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,sCAAsC;QACtC,SAAS;QACT,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,0BAA0B;QAC1B,SAAS;QACT,kBAAkB;QAClB,uBAAuB;IAC3B;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;QACf,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,0BAA0B;AAC9B","sourcesContent":[".AgendaPage {\n    margin-top: 10vh;\n}\n\n.agenda-page {\n    padding: 80px 20px;\n    background-color: #f8f9fa;\n    min-height: calc(100vh - 20vh);\n}\n\n.agenda-container {\n    max-width: 1400px;\n    margin: 0 auto;\n}\n\n.agenda-title {\n    font-size: 2.5rem;\n    text-align: center;\n    margin-bottom: 30px;\n    color: #333;\n}\n\n.agenda-intro {\n    font-size: 1.1rem;\n    line-height: 1.8;\n    text-align: center;\n    margin-bottom: 50px;\n    color: #555;\n    max-width: 1000px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.agenda-table {\n    background: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n    overflow: hidden;\n}\n\n.agenda-row {\n    display: grid;\n    grid-template-columns: 180px 1fr 400px;\n    gap: 25px;\n    padding: 25px 20px;\n    border-bottom: 1px solid #e9ecef;\n    align-items: center;\n}\n\n.agenda-row:last-child {\n    border-bottom: none;\n}\n\n.agenda-row.header {\n    background-color: #2c3e50;\n    color: white;\n    font-weight: bold;\n    border-bottom: 3px solid #1a252f;\n    padding: 20px;\n}\n\n.agenda-row.header .agenda-time,\n.agenda-row.header .agenda-item,\n.agenda-row.header .agenda-people {\n    color: white;\n    font-size: 1rem;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    text-align: center;\n}\n\n.agenda-row.highlight {\n    background-color: #f8f9fa;\n}\n\n.agenda-time {\n    font-weight: 600;\n    color: #2c3e50;\n    font-size: 0.95rem;\n    white-space: nowrap;\n    text-align: center;\n}\n\n.agenda-item {\n    color: #333;\n    line-height: 1.7;\n    font-size: 0.95rem;\n    text-align: center;\n}\n\n.agenda-item strong {\n    color: #2c3e50;\n    font-size: 1.05rem;\n    display: block;\n    margin-bottom: 5px;\n}\n\n.agenda-item em {\n    color: #2c3e50;\n    font-size: 0.95rem;\n    display: block;\n    margin-bottom: 4px;\n}\n\n.agenda-abstract {\n    font-size: 0.85rem;\n    color: #666;\n    line-height: 1.6;\n    display: block;\n    margin-top: 4px;\n}\n\n.agenda-people {\n    color: #555;\n    font-size: 0.9rem;\n    line-height: 1.8;\n    text-align: center;\n}\n\n.agenda-people strong {\n    color: #2c3e50;\n    font-weight: 600;\n    display: block;\n    margin-top: 8px;\n    margin-bottom: 4px;\n}\n\n.agenda-people strong:first-child {\n    margin-top: 0;\n}\n\n@media (max-width: 1024px) {\n    .agenda-row {\n        grid-template-columns: 150px 1fr 300px;\n        gap: 20px;\n        padding: 20px 15px;\n    }\n}\n\n@media (max-width: 768px) {\n    .agenda-row {\n        grid-template-columns: 1fr;\n        gap: 12px;\n        padding: 20px 15px;\n        align-items: flex-start;\n    }\n    \n    .agenda-time {\n        font-weight: bold;\n        margin-bottom: 8px;\n        font-size: 1rem;\n        color: #2c3e50;\n        text-align: left;\n    }\n    \n    .agenda-item {\n        margin-bottom: 12px;\n        text-align: left;\n    }\n    \n    .agenda-people {\n        margin-bottom: 0;\n        text-align: left;\n    }\n    \n    .agenda-title {\n        font-size: 2rem;\n    }\n    \n    .agenda-intro {\n        font-size: 1rem;\n    }\n    \n    .agenda-row.header {\n        display: none;\n    }\n}\n\n.agenda-subtitle {\n    font-size: 0.9em;\n    font-weight: normal;\n    color: #555;\n}\n\n.agenda-link {\n    color: #57068c;\n    text-decoration: none;\n    font-weight: 500;\n}\n.agenda-link:hover {\n    text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
